<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="250"
            :selectable-rows="true"
          >
            <template #head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template #head(customerNumber)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.customerNumber" />
            </template>
            <template #head(alternativeArticleId)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.alternativeArticleId" />
            </template>
            <template #head(type)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.type" />
            </template>
            <template #head(info)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.info" />
            </template>
            <template #head(primaryKey)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.primaryKey" />
            </template>
            <template #head(table)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.table" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import { NotificationMixin, ArticleMixin } from '../../../mixins';
import TableFilter from '../../table/table-filter';
import PageHeader from '../../structure/page-header';

export default {
  name: 'ArticleAlternatives',
  components: { PageHeader, DataTable, TableFilter },
  mixins: [NotificationMixin, ArticleMixin],
  data: function() {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          { key: 'company', label: this.$translate('company') },
          { key: 'customerNumber', label: this.$translate('account') },
          {
            key: 'alternativeArticleId',
            label: this.$translate('alternative_article_id'),
          },
          { key: 'type', label: this.$translate('type') },
          { key: 'info', label: this.$translate('info') },
          { key: 'primaryKey', label: this.$translate('primary_key') },
          { key: 'table', label: this.$translate('table') },
        ],
        filter: {
          company: null,
          customerNumber: null,
          alternativeArticleId: null,
          type: null,
          info: null,
          primaryKey: null,
          table: null,
        },
      },
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.articleService.getArticleAlternatives(ctx);
        return { totalCount: response.totalCount, data: response.data };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>
